(() => {
  const CONFIG = {
    41660131737684: { bonusVariantId: 41738144546900,  perTriggerQty: 1, ensureQtyMatchesTrigger: true, once: false },
    41660131770452: { bonusVariantId: 41738144579668, perTriggerQty: 1, ensureQtyMatchesTrigger: true, once: false },
    41660131803220: { bonusVariantId: 41738144743508,  perTriggerQty: 1, ensureQtyMatchesTrigger: true, once: false }
  };

  const state = { addingBonus: false };

  const getCart = async () => {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    const j = await r.json();
    return j;
  };

  const addVariant = async (variantId, qty) => {
    console.log('[BonusAdd] POST /cart/add.js', { id: variantId, quantity: qty });
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    const bodyText = await r.text();
    const body = safeJson(bodyText);
    if (!r.ok) {
      console.error('[BonusAdd] add.js FAILED', r.status, body || bodyText);
      throw new Error('add failed');
    }
    console.log('[BonusAdd] add.js OK', body);
    return body;
  };

  const changeToQty = async (variantId, qty) => {
    console.log('[BonusAdd] POST /cart/change.js -> set', variantId, 'to', qty);
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    const bodyText = await r.text();
    const body = safeJson(bodyText);
    if (!r.ok) {
      console.error('[BonusAdd] change.js FAILED', r.status, body || bodyText);
      throw new Error('change failed');
    }
    console.log('[BonusAdd] change.js OK');
    return body;
  };

  const safeJson = (t) => {
    try { return JSON.parse(t); } catch { return null; }
  };

  const normalizeAdded = async (respJson) => {
    if (!respJson) return [];
    if (respJson.items && Array.isArray(respJson.items)) {
      return respJson.items.map(i => ({
        product_id: i.product_id,
        variant_id: i.variant_id ?? i.id,
        quantity: i.quantity ?? 1
      }));
    }
    if (respJson.id && (respJson.product_id || respJson.product)) {
      return [{
        product_id: respJson.product_id ?? respJson.product?.id,
        variant_id: respJson.variant_id ?? respJson.id,
        quantity: respJson.quantity ?? 1
      }];
    }
    return [];
  };

  const ensureBonuses = async (addedItems) => {
    if (!addedItems.length || state.addingBonus) return;

    const triggers = addedItems.filter(it => CONFIG[it.variant_id]);
    if (!triggers.length) {
      console.log('[BonusAdd] No matching trigger variant IDs in', addedItems.map(i => i.variant_id));
      return;
    }

    console.log('[BonusAdd] Found triggers:', triggers.map(t => t.variant_id));
    const cart = await getCart();

    const cartQtyByVariant = {};
    for (const li of cart.items) {
      const vid = li.variant_id ?? li.id;
      cartQtyByVariant[vid] = (cartQtyByVariant[vid] || 0) + li.quantity;
    }

    // Build actions
    const adds = [];
    const syncs = [];
    for (const t of triggers) {
      const rule = CONFIG[t.variant_id];
      const triggerQty = t.quantity || 1;
      const desiredQty = rule.once
        ? Math.min(1, triggerQty * (rule.perTriggerQty || 1))
        : (rule.ensureQtyMatchesTrigger
            ? triggerQty * (rule.perTriggerQty || 1)
            : (cartQtyByVariant[rule.bonusVariantId] ? 0 : (rule.perTriggerQty || 1)));

      const current = cartQtyByVariant[rule.bonusVariantId] || 0;
      console.log(`[BonusAdd] Trigger ${t.variant_id} -> bonus ${rule.bonusVariantId}. desired=${desiredQty}, current=${current}`);

      if (desiredQty <= 0) continue;

      if (current === 0) {
        // Not in cart yet: add via /cart/add.js
        adds.push({ id: rule.bonusVariantId, qty: desiredQty });
      } else if (rule.ensureQtyMatchesTrigger && current !== desiredQty) {
        // Already present but needs sync
        syncs.push({ id: rule.bonusVariantId, qty: desiredQty });
      }
    }

    if (!adds.length && !syncs.length) {
      console.log('[BonusAdd] No adds/syncs needed.');
      return;
    }

    console.log('[BonusAdd] Will apply:', { adds, syncs });
    state.addingBonus = true;
    try {
      for (const a of adds) await addVariant(a.id, a.qty);
      for (const s of syncs) await changeToQty(s.id, s.qty);
    } catch (e) {
      // errors already logged above
    } finally {
      state.addingBonus = false;
    }
  };

  const wrapFetch = () => {
    if (window.__bonusFetchWrapped) return;
    window.__bonusFetchWrapped = true;

    const origFetch = window.fetch;
    window.fetch = async function(input, init = {}) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = (init?.method || (typeof input !== 'string' ? input.method : 'GET') || 'GET').toUpperCase();
      const isAdd = url.includes('/cart/add.js') && method === 'POST';

      const resp = await origFetch.apply(this, arguments);

      if (isAdd) {
        try {
          const clone = resp.clone();
          const json = await clone.json();
          const added = await normalizeAdded(json);
          console.log('[BonusAdd] /cart/add.js detected. Added items:', added.map(i => i.variant_id));
          await ensureBonuses(added);
        } catch (e) {
          console.error('[BonusAdd] Error parsing add.js response', e);
        }
      }
      return resp;
    };
  };

  const init = () => {
    console.log('[BonusAdd] Script initialized.');
    wrapFetch();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();